/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { PatientAbleToWalk } from 'app/shared/model/enumerations/patient-able-to-walk.model';
import { Pain } from 'app/shared/model/enumerations/pain.model';
import { PatientCondition } from 'app/shared/model/enumerations/patient-condition.model';

export interface IPostOpRecoveryDischarge {
  id?: string;
  vitalsStable?: boolean;
  patientAbleToWalk?: keyof typeof PatientAbleToWalk | null;
  vomiting?: boolean;
  bleeding?: boolean;
  pain?: keyof typeof Pain | null;
  conditionAtDischarge?: keyof typeof PatientCondition | null;
  dischargeCriteria?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  recoveryDoctor?: IDoctor;
}

export const defaultValue: Readonly<IPostOpRecoveryDischarge> = {
  vitalsStable: false,
  vomiting: false,
  bleeding: false,
  dischargeCriteria: false,
  active: false,
};
